
import Vue from 'vue'

export default Vue.extend({
  computed: {
    slotPassed() {
      return !!(this.$slots.default || [])[0]
    },
  },
})
